module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_10.d82df4e9.png";